import { takeEvery, takeLatest, all } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import { dataFormatsRequest, dataFormatsUpdateRequest } from '@store/dataFormats';

export default all([
  takeLatest(dataFormatsRequest.type, handleRequest),
  takeEvery(dataFormatsUpdateRequest.type, handleRequest),
]);
